// extracted by mini-css-extract-plugin
export var searchHeader = "_8c-0";
export var searchHeaderDark = "_8c-1";